import React, { useState } from 'react';
import './NoticeReplyForm.css';

const NoticeReplyForm = ({ notice, onBack, onSubmit }) => {
  const [responses, setResponses] = useState({});
  const [errors, setErrors] = useState({});

  const handleInputChange = (actionId, value) => {
    setResponses(prev => ({
      ...prev,
      [actionId]: value
    }));
    
    // Clear error when user starts typing
    if (errors[actionId]) {
      setErrors(prev => ({
        ...prev,
        [actionId]: null
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    notice.actions.forEach(action => {
      if (action.required && (!responses[action.id] || responses[action.id].trim() === '')) {
        newErrors[action.id] = '此項目為必填';
      }
    });
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      onSubmit(responses);
    }
  };

  const renderActionInput = (action) => {
    switch (action.type) {
      case 'attendance':
      case 'choice':
      case 'enrollment':
        return (
          <div className="radio-group">
            {action.options.map((option, index) => (
              <label key={index} className="radio-option">
                <input
                  type="radio"
                  name={action.id}
                  value={option}
                  checked={responses[action.id] === option}
                  onChange={(e) => handleInputChange(action.id, e.target.value)}
                />
                <span className="radio-label">{option}</span>
              </label>
            ))}
          </div>
        );
      
      case 'feedback':
        return (
          <textarea
            className="text-input"
            placeholder={`請輸入${action.title}...`}
            value={responses[action.id] || ''}
            onChange={(e) => handleInputChange(action.id, e.target.value)}
            rows={3}
          />
        );
      
      default:
        return (
          <input
            type="text"
            className="text-input"
            placeholder={`請輸入${action.title}...`}
            value={responses[action.id] || ''}
            onChange={(e) => handleInputChange(action.id, e.target.value)}
          />
        );
    }
  };

  return (
    <div className="notice-reply-container">
      <div className="notice-reply-header">
        <button className="back-button" onClick={onBack}>
          ← 通告
        </button>
        <h2>回條簽署</h2>
      </div>

      <div className="notice-reply-content">
        {/* Notice Title */}
        <div className="reply-notice-title">
          <h3>{notice.title}</h3>
        </div>

        {/* Reply Form */}
        <form onSubmit={handleSubmit} className="reply-form">
          {notice.actions && notice.actions.map((action) => (
            <div key={action.id} className="form-group">
              <label className="form-label">
                {action.title}
                {action.required && <span className="required">*</span>}
              </label>
              
              {renderActionInput(action)}
              
              {errors[action.id] && (
                <div className="error-message">{errors[action.id]}</div>
              )}
            </div>
          ))}

          {/* Submit Instructions */}
          <div className="submit-instructions">
            <p>請填妥以上回條，再按簽署。</p>
          </div>

          {/* Submit Button */}
          <div className="form-actions">
            <button type="submit" className="submit-button">
              簽署
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NoticeReplyForm;
